import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import RightArrow from "../../assets/svg/RightArrow";
import styles from "./Privacy.module.scss";
import { toast } from "react-toastify";
import axios from "../../components/Hooks/axios";
import { useDispatch, useSelector } from "react-redux";
import { setUserObject } from "../../redux/slices/authSlice";

export const Message = () => {
    return (
        <div className={styles.ComingSoon} style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
            <h2 style={{ color: '#A6539D', fontSize: '1.5rem', fontWeight: '500' }}>Messages Feature Coming Soon...</h2>
        </div>
    );
};


